import { useEffect, useState } from "react";
import { api, imageUrl } from "@/lib/api";
import { Link } from "react-router-dom";
import { ClockCounterClockwise } from "@phosphor-icons/react";

export default function Timeline() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/timeline").then((r) => setData(r.data)).catch(() => setData([])); }, []);

  return (
    <div className="mx-auto max-w-[1400px]">
      <p className="overline text-[#F27A54]">My Photo Journey</p>
      <h1 className="mt-1 font-display text-3xl font-black tracking-tight">Timeline</h1>

      {data === null ? (
        <p className="mt-8 text-muted-foreground">Loading…</p>
      ) : data.length === 0 ? (
        <div className="mt-16 grid place-items-center text-center">
          <ClockCounterClockwise size={44} weight="thin" className="text-zinc-300" />
          <p className="mt-3 font-display font-bold">No photos yet</p>
        </div>
      ) : (
        <div className="mt-8 space-y-10 border-l-2 border-border pl-6">
          {data.map((yr) => (
            <div key={yr.year} className="relative">
              <span className="absolute -left-[31px] top-1 h-4 w-4 rounded-full border-4 border-white bg-[#F27A54]" />
              <div className="flex items-baseline gap-3">
                <h2 className="font-display text-2xl font-black tracking-tight">{yr.year}</h2>
                <span className="font-mono-p text-sm text-muted-foreground">{yr.count} photos</span>
              </div>
              <div className="mt-3 flex gap-3 overflow-x-auto pb-2">
                {yr.photos.map((p) => (
                  <Link key={p.id} to={`/photos/${p.id}`} className="group relative w-40 flex-shrink-0">
                    <img src={imageUrl(p.id)} alt="" className="h-28 w-40 rounded-md border border-border object-cover transition-transform duration-200 group-hover:-translate-y-1" />
                    <p className="mt-1 line-clamp-1 text-xs font-medium">{p.caption || "Photo"}</p>
                    <p className="text-[10px] text-muted-foreground">{[p.city, p.country].filter(Boolean).join(", ")}</p>
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
